import dayjs from 'dayjs';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { DateFormat } from '@/modules/core/app/constants/date.constants';

export class BillingSubscriptionHistory extends BaseEntityModel {
  id: number;
  billingId: number;
  subscriptionStartsAt?: string;
  subscriptionEndsAt?: string;
  /** @deprecated DEV-21526 no longer written by the API; kept for backward compatibility only. */
  subscriptionAmount?: number;
  subscriptionPaidAt?: string;

  constructor(model: Partial<BillingSubscriptionHistory> = {}) {
    super(model);

    this.id = model.id as number;
    this.billingId = model.billingId as number;
    this.subscriptionStartsAt = model.subscriptionStartsAt;
    this.subscriptionEndsAt = model.subscriptionEndsAt;
    this.subscriptionAmount = model.subscriptionAmount;
    this.subscriptionPaidAt = model.subscriptionPaidAt;
  }

  get formattedSubscriptionEndsAt(): string {
    if (!this.subscriptionEndsAt) {
      return '';
    }
    const dateOnly: string = this.subscriptionEndsAt.substring(0, 10);
    return dayjs(dateOnly).format(DateFormat.FULL_MONTH_DAY_YEAR);
  }
}
